import { lazy } from "react";

const customOrderAnalysis = lazy(() => import("../view/customOrder/customOrderAnalysis"));
const customOrderDetails = lazy(() => import("../view/customOrder/customOrderDetails"));
const customOrder = [
  // 客订单统计
  {
    path: "/customOrder/customOrderAnalysis",
    component: customOrderAnalysis,
  },
  // 客订单明细
  {
    path: "/customOrder/customOrderDetails",
    component: customOrderDetails,
  },
];
export default customOrder;